<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <template v-slot:header>
        <h5>Daftar Disbursement</h5>
      </template>

      <b-row class="mb-3">
        <b-col cols="12" md="6">
          <b-form-group label="Cabang">
            <multiselect name="dariCabang" v-model="filters.cabang" :options="optionsCabang" :internal-search="true"
              :allow-empty="false" deselect-label="" select-label="" label="name" track-by="name"
              placeholder="Cabang" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="6">
          <b-form-group label="No. Faktur">
            <b-form-input v-model="filters.noFaktur" id="filterInput" type="search" placeholder="Masukkan No. Faktur"
              @keyup.enter="onSearch()" />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12" lg="6">
          <b-form-group label="Tanggal">
            <div class="d-flex" :class="isMobile ? 'flex-wrap' : ''">
              <b-form-input v-model="filters.startDate" name="filterFromDate" id="filterDate" type="date"
                class="flex-fill"></b-form-input>
              <span class="ml-2 mr-2 d-flex align-items-center">s/d</span>
              <b-form-input v-model="filters.endDate" name="filterToDate" type="date" class="flex-fill"></b-form-input>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <div class="d-flex flex-wrap justify-content-between gap-2">
            <div class="d-flex flex-wrap gap-2">
              <b-button variant="pgiBtn" :disabled="isBusy" class="mr-2" @click="onSearch()">
                Search
              </b-button>
              <b-button variant="pgiBtn" :disabled="isBusy" @click="onReset()">Reset</b-button>
            </div>
            <div>
              <b-button variant="pgiBtn" :disabled="isBusy" @click="confirmDownloadExcel">
                <i class="fa fa-download mr-2"></i>
                Download Excel
              </b-button>
            </div>
          </div>
        </b-col>
      </b-row>

      <div class="detail-data-wrapper">
        <b-table bordered hover show-empty :busy="isBusy" :items="data" :no-local-sorting="false" :fields="fields"
          responsive class="mb-3">
          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading data...</strong>
            </div>
          </template>
          <template v-slot:empty>
            Tidak ada data.
          </template>
          <template v-slot:cell(noFakturAndCabang)="row">
            <p class="mb-0 normalText">{{ row.item.noFaktur }}</p>
            <p class="mb-0 smallText text-muted">{{ row.item.cabang }}</p>
            <span class="status-box-md status-box-primary">Kelas {{ row.item.branchClass }}</span>
          </template>
          <template v-slot:cell(nasabah)="row">
            <p class="mb-0 normalText"><span class="text-muted">No. Anggota:</span> {{ row.item.noAnggota }}</p>
            <p class="mb-0 normalText"><span class="text-muted">Nama Anggota:</span> {{ row.item.namaNasabah }}</p>
            <p class="mb-0 normalText"><span class="text-muted">Bank:</span> {{ row.item.namaBank }}</p>
            <p class="mb-0 normalText"><span class="text-muted">No. Rekening:</span> {{ row.item.noRekening }}</p>
            <p class="mb-0 normalText"><span class="text-muted">Nama Rekening:</span>
              {{ row.item.namaPemilikRekening }}</p>
          </template>
          <template v-slot:cell(informasiTransaksi)="row">
            <p class="mb-0 normalText">{{ row.item.jenisBarang }}</p>
            <p class="mb-0 text-muted">{{ row.item.merkBarang }} - {{ row.item.tipeBarang }}</p>
            <p class="mb-0 text-muted">{{ $helper.formatDateAndHour(row.item.tanggalGadai) }}</p>
            <p class="mb-0">Pinjaman: Rp. {{ $helper.addThousandSeparator(row.item.pinjamanPokokAwal) }}</p>
            <p class="mb-0">Maksimal: Rp. {{ $helper.addThousandSeparator(row.item.pinjamanMaksimum) }}</p>
            <p class="mb-0">Pencairan: Rp. {{ $helper.addThousandSeparator(row.item.transferAmount) }}</p>
            <p class="mb-0">Dibuat oleh: {{ row.item.createdBy }}</p>
          </template>
          <template v-slot:cell(status)="row">
            <span :class="statusDisbursementClass(row.item.statusDisburse)">{{
              statusDisbursementLabel(row.item.statusDisburse)
              }}</span>
          </template>
          <template v-slot:cell(action)="row">
            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="detailDisbursement"
              @click="onShowModalDetail(row.item)">
              <i class="fa fa-info"></i>
            </b-button>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-between">
          <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
            <b-form-select v-model="show" @change="onLimitChange" :options="optionsLimit">
              <template v-slot:first>
                <b-form-select-option :value="null" disabled />
              </template>
            </b-form-select>
            <span class="ml-2">{{ totalViewText }}</span>
          </b-input-group>
          <b-pagination class="mb-0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            aria-controls="my-table" @input="onPageChange"></b-pagination>
        </div>
      </div>
    </b-card>
    <b-modal id="modal-detail-disbursement" size="xl" title="Detail Disbursement" no-close-on-backdrop hide-footer>
      <StateDetailHandler :isLoading="detailState.isLoading" :isError="detailState.isError" :lines="10"
        @retry="getAllDetails">
        <DetailGadaiKomp :detailGadai="selectedRowGadai" :detailMetodePencairan="selectedRowDisburse"
          :isApprovalPage="true" />
        <b-row class="mt-3" v-if="selectedRowDisburse">
          <b-col cols="12" class="mb-3">
            <div class="detail-data-wrapper mb-0">
              <h6 class="form-title">DAFTAR REKENING</h6>
            </div>
            <div class="mt-2">
              <b-button variant="pgiBtn" size="sm" @click="onShowModalListRekening">
                Lihat {{ stateListRekening.data.length }} Rekening
              </b-button>
            </div>
          </b-col>
          <b-col cols="12" class="mb-3">
            <DetailMetodePencairan :data="selectedRowDisburse" />
          </b-col>
          <b-col cols="12">
            <div class="detail-data-wrapper mb-0">
              <h6 class="form-title">METODE PENCAIRAN</h6>
            </div>
            <b-row>
              <b-col cols="12" class="mb-3">
                <strong>
                  Non Tunai (Transfer)
                </strong>
              </b-col>
              <b-col cols="12" class="mb-2">
                <b-alert show variant="secondary" class="pb-4">
                  <p class="mb-2 font-md font-semi-bold">
                    Rekening tujuan:
                  </p>
                  <div v-if="selectedRowDisburse.chooseRekening">
                    <div>
                      <i class="fa fa-credit-card mr-1"></i>
                      <strong>{{ selectedRowDisburse.chooseRekening.bankName }}</strong>
                    </div>
                    <p class="mb-0">{{ selectedRowDisburse.chooseRekening.noRekening }}</p>
                    <p class="mb-0">{{ selectedRowDisburse.chooseRekening.namePemilikRekening }}</p>
                  </div>
                </b-alert>
              </b-col>
              <b-col cols="12" class="mb-2" v-if="selectedRowDisburse.identityType">
                <p class="mb-0 font-bold">{{ selectedRowDisburse.identityType }} - <span
                    class="status-box status-box-primary">{{ selectedRowDisburse.identityNo }}</span></p>
              </b-col>
              <b-col cols="12" sm="6" class="mb-3">
                <div v-if="selectedRowDisburse.identityPhoto">
                  <a :href="selectedRowDisburse.identityPhoto" target="_blank">
                    <b-img :src="selectedRowDisburse.identityPhoto" thumbnail fluid
                      alt="Foto" style="max-height: 175px;" />
                  </a>
                </div>
              </b-col>
              <b-col cols="12" sm="6">
                <div class="mb-2 wrapper-identitas-and-amount">
                  <p class="mb-0 font-bold small">Nama:</p>
                  <p class="mb-0" v-if="selectedRowGadai">
                    {{ selectedRowGadai.anggota.namaAnggota }}
                  </p>
                </div>
                <div class="wrapper-identitas-and-amount">
                  <p class="mb-0 font-bold small">Jumlah Pencairan:</p>
                  <p class="mb-0" v-if="selectedRowDisburse">
                    Rp {{ $helper.addThousandSeparator(selectedRowDisburse.totalTransfer) }}
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </StateDetailHandler>
    </b-modal>

    <ModalListRekeningBank :stateListRekening="detailState" :dataListRekening="stateListRekening.data"
      :userData="selectedRowGadai ? selectedRowGadai.anggota : {}" :isReadOnly="true" />

    <ModalConfirm id="modal-confirm-excel" title="Konfirmasi Download Excel" :isSubmitting="isLoadingExcel"
      desc="Apakah Anda yakin ingin mendownload daftar disbursement dalam format Excel?"
      @submit="openModalDownloadExcel" />

    <b-modal id="modal-download-excel" centered title="Download Excel" hide-footer no-close-on-backdrop>
      <div class="show-btn-download">
        <p class="">
          Silakan download dengan klik tombol dibawah ini :
        </p>
        <b-button variant="pgiBtn" class="mb-0 download-btn">
          <a v-bind:href="$baseFilePath + filePathDownload" download>
            <i class="fa fa-download mr-2"></i>
            Download Excel
          </a>
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import StateDetailHandler from '@/components/common/StateDetailHandler'
import DetailGadaiKomp from '@/components/gadai/DetailGadaiKomp'
import DetailMetodePencairan from '@/components/rekening/DetailMetodePencairan'
import ModalListRekeningBank from '@/components/modals/ModalListRekeningBank'
import CONSTANTS from '@/constants'

export default {
  components: {
    StateDetailHandler,
    DetailGadaiKomp,
    DetailMetodePencairan,
    ModalListRekeningBank,
  },
  data() {
    return {
      initStatus: 1,
      isBusy: false,
      filters: {
        noFaktur: '',
        cabang: null,
        startDate: null,
        endDate: null,
      },
      optionsCabang: [],
      data: [],
      fields: [
        { key: "noFakturAndCabang", label: "No. Faktur & Cabang" },
        { key: "nasabah", label: "Nasabah", thClass: 'min-width-200', tdClass: 'min-width-200' },
        { key: "informasiTransaksi", label: "Informasi Transaksi", thClass: 'min-width-200', tdClass: 'min-width-200' },
        { key: "status", label: "Status", thClass: 'text-center', tdClass: 'text-center' },
        { key: "action", label: "Aksi", thClass: 'text-center', tdClass: 'text-center' },
      ],
      selectedRowDisburse: null,
      selectedRowGadai: null,
      selectedGadaiId: null,
      detailState: {
        isLoading: false,
        isError: false,
      },
      currentPage: 1,
      show: 10,
      perPage: 10,
      totalRows: 0,
      totalPages: 0,
      totalViewText: "",
      optionsLimit: CONSTANTS.OPTIONS_LIMIT_PAGINATION,
      isMobile: false,
      stateListRekening: {
        data: [],
      },
      isLoadingExcel: false,
      filePathDownload: ''
    }
  },
  computed: {
    STATUS_DISBURSEMENT_APPROVAL() {
      return CONSTANTS.GADAI.STATUS_DISBURSEMENT_APPROVAL
    },
    STATUS_DISBURSEMENT_GADAI() {
      return CONSTANTS.GADAI.STATUS_DISBURSEMENT_GADAI
    },
  },
  methods: {
    async init() {
      this.initStatus = 0
      try {
        this.getCabang()
        await this.getItems()
        this.initStatus = 1
      } catch (error) {
        this.$helper.parseError(this, error)
        this.initStatus = -1
      }
    },
    getItems(page = 1) {
      this.isBusy = true
      this.data = []
      this.currentPage = isNaN(page) ? 1 : page

      const params = this.buildQueryParams()

      return this.$axios.get("gadai-disburse/get-gadai-disbursement", {
        params,
      }).then(res => {

        this.data = res.data.content
        this.totalRows = res.data.totalElements

        let pg = this.currentPage - 1

        let prev = pg * this.show + 1
        let limit = pg * this.show + this.show
        if (limit > this.totalRows) limit = this.totalRows

        this.totalViewText = "Menampilkan " + prev + " - " + limit + " dari " + this.totalRows + " entri"
      }).catch(error => {
        this.$helper.parseError(this, error)
        throw error
      })
        .finally(() => {
          this.isBusy = false
        })
    },
    onLimitChange(newPerPage) {
      this.perPage = newPerPage
      this.getItems()
    },
    onPageChange(newPage) {
      this.getItems(newPage)
    },
    onSearch() {
      const isInvalidDateRange = this.$helper.isInvalidDateRange(this.filters.startDate, this.filters.endDate)

      if (isInvalidDateRange) {
        this.$helper.toastErr(this, 'Tanggal mulai tidak boleh lebih dari tanggal akhir')
        return;
      }

      this.getItems()
    },
    onReset() {
      this.filters = {
        noFaktur: '',
        cabang: null,
        startDate: null,
        endDate: null,
      }

      this.getItems()
    },
    getCabang() {
      const getCabang = localStorage.getItem("cabang")
      const cabang = JSON.parse(getCabang);

      const mappingName = cabang.map(item => ({
        ...item,
        name: item.name.replace(/^\(\d+\)\s*/, "")
      }));

      this.optionsCabang = [
        { id: null, name: "Semua Cabang" },
        ...mappingName
      ]
    },
    onShowModalDetail(row) {
      this.selectedRowDisburse = row;
      this.selectedGadaiId = row.gadaiId;
      this.$bvModal.show('modal-detail-disbursement')
      this.getAllDetails();
    },
    onShowModalListRekening() {
      this.$bvModal.show("modal-list-rekening-bank")
    },
    getDetailGadai() {
      const gadaiId = this.selectedGadaiId;
      return this.$axios.get(`gadai/detail/id/${gadaiId}`);
    },
    getDetailDisbursement() {
      const disburseId = this.selectedRowDisburse.disbursementId;
      return this.$axios.get(`gadai-disburse/get-disbursement/${disburseId}`);
    },
    getDetailApproval() {
      const disburseId = this.selectedRowDisburse.disbursementId;
      return this.$axios.get(`gadai-disburse/check-approval-detail/${disburseId}`);
    },
    getListRekening(id) {
      return this.$axios.get(`nasabah/list-bank/${id}`)
    },
    statusDisbursementLabel(status) {
      const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
      switch (status) {
        case statusDisburse.WAIT_APPROVAL:
          return 'Menunggu Persetujuan';
        case statusDisburse.APPROVED_ALL:
          return 'Persetujuan Lengkap';
        case statusDisburse.DISBURSED:
          return 'Berhasil Cair';
        case statusDisburse.DANA_DITANGGUHKAN:
          return 'Dana Ditangguhkan';
        case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
          return 'Gagal Cair';
        case statusDisburse.CEK_IT:
          return 'Mohon Hubungi IT';
        case statusDisburse.CANCELLED:
          return 'Dibatalkan';
        case statusDisburse.REJECTED:
          return 'Ditolak';
        default:
          return '-';
      }
    },
    statusDisbursementClass(status) {
      const statusDisburse = this.STATUS_DISBURSEMENT_GADAI;
      switch (status) {
        case statusDisburse.WAIT_APPROVAL:
          return 'status-box status-box-warning';
        case statusDisburse.APPROVED_ALL:
          return 'status-box status-box-success';
        case statusDisburse.DISBURSED:
          return 'status-box status-box-primary';
        case statusDisburse.DANA_DITANGGUHKAN:
          return 'status-box status-box-warning';
        case statusDisburse.DANA_DITANGGUHKAN_GAGAL:
          return 'status-box status-box-danger';
        case statusDisburse.CEK_IT:
          return 'status-box status-box-danger';
        case statusDisburse.CANCELLED:
          return 'status-box status-box-secondary';
        case statusDisburse.REJECTED:
          return 'status-box status-box-danger';
        default:
          return '';
      }
    },
    async getAllDetails() {
      this.detailState.isLoading = true;
      this.detailState.isError = false;

      try {
        const [gadaiRes, disburseRes, approvalRes] = await Promise.all([
          this.getDetailGadai(),
          this.getDetailDisbursement(),
          this.getDetailApproval(),
        ]);

        const listRekeningRes = await this.getListRekening(
          gadaiRes.data.anggota.nasabahId
        );

        this.selectedRowGadai = gadaiRes.data;
        const disburseData = disburseRes.data;
        const approvalData = approvalRes.data;
        this.stateListRekening.data = listRekeningRes.data
        this.selectedRowDisburse = {
          ...this.selectedRowDisburse,
          feeBank: disburseData.fee,
          chooseRekening: {
            bankName: disburseData.nasabahBankName,
            noRekening: disburseData.nasabahBankNumber,
            nasabahName: disburseData.nasabahName,
            namePemilikRekening: this.selectedRowDisburse.namaPemilikRekening,
          },
          statusAll: disburseData.status,
          dataApproval: approvalData.approvals,
          totalTransfer: disburseData.totalTransfer,
          identityPhoto: disburseData.identityPhoto,
          identityType: disburseData.identityType,
          identityNo: disburseData.identityNo,
        };
      } catch (error) {
        this.$helper.parseError(this, error);
        this.detailState.isError = true;
      } finally {
        this.detailState.isLoading = false;
      }
    },
    confirmDownloadExcel() {
      const isInvalidDateRange = this.$helper.isInvalidDateRange(this.filters.startDate, this.filters.endDate)

      if (isInvalidDateRange) {
        this.$helper.toastErr(this, 'Tanggal mulai tidak boleh lebih dari tanggal akhir')
        return;
      }

      this.filePathDownload = '';
      this.$bvModal.show("modal-confirm-excel")
    },
    openModalDownloadExcel() {
      this.isLoadingExcel = true;
      const params = this.buildQueryParams();
      delete params.page
      delete params.size

      this.$axios.get("gadai-disburse/export-gadai-disbursement", {
        params,
      }).then(res => {
        this.filePathDownload = res.data.name
        this.$bvModal.show("modal-download-excel")
        this.$bvModal.hide("modal-confirm-excel")
      }).catch(error => {
        this.$helper.parseError(this, error)
      })
        .finally(() => {
          this.isLoadingExcel = false;
        })
    },
    buildQueryParams() {
      const params = {
        page: this.currentPage - 1,
        size: this.perPage,
      }

      if (!this.$helper.isNullOrEmpty(this.filters.noFaktur)) {
        params.noFaktur = this.filters.noFaktur;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.startDate)) {
        params.startDate = this.filters.startDate;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.endDate)) {
        params.endDate = this.filters.endDate;
      }

      if (!this.$helper.isNullOrEmpty(this.filters.cabang)) {
        params.cabangName = this.filters.cabang.name;
      }

      if (this.filters.cabang && this.filters.cabang.id === null) {
        delete params.cabangName
      }

      return params
    },
    handleResize() {
      this.isMobile = window.innerWidth <= 576;
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
}
</script>
